import React from 'react'

import withDefaultStyles from './withDefaultStyles'

const FillInfo = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M12 2H11.81C6.39001 2 2.00001 6.4022 2.00001 11.8249C1.96001 14.4962 3.00001 17.0675 4.89001 18.9585C6.77001 20.8694 9.32001 21.96 12 22C12.07 22 12.14 22 12.21 22C17.63 21.99 22.01 17.5878 22 12.1651C22.05 6.6023 17.57 2.05003 12 2ZM12.82 16.3672C12.82 16.8274 12.45 17.1976 11.99 17.1976C11.53 17.1976 11.16 16.8274 11.16 16.3672V11.3647C11.16 10.9045 11.53 10.5343 11.99 10.5343C12.45 10.5343 12.82 10.9045 12.82 11.3647V16.3672ZM11.99 9.31366C11.99 9.31366 11.94 9.31366 11.92 9.31366C11.24 9.28364 10.71 8.71336 10.74 8.03302C10.77 7.34267 11.34 6.8024 12.03 6.81241C12.05 6.81241 12.06 6.81241 12.08 6.81241C12.76 6.84242 13.28 7.41271 13.25 8.08304C13.22 8.76338 12.67 9.30365 11.98 9.30365L11.99 9.31366Z"
      fill="#565B6D"
    />
  </svg>
)

export default withDefaultStyles(FillInfo)
